import { createClient } from '@supabase/supabase-js'
export const supabase = createClient(
  'https://dffjrbdtowdttossjgzx.supabase.co',
  'sb_publishable_xl907EP_nClECGtJ9zZLyw_HjdljGmi'
)
